import { Grid2 as Grid, IconButton, Typography } from '@mui/material'
import InputBase from 'design-system/input/base'
import React, { useEffect, useState } from 'react'
import { postChatMessage } from 'services/chat'
import Storage from 'storage/auth'
import SendIcon from '@mui/icons-material/Send'
import { useToast } from 'services/context/toast'

interface SendMessageAreaProps {
  chatId?: string
  disabled?: boolean
}

const SendMessageArea: React.FC<SendMessageAreaProps> = ({
  chatId,
  disabled
}) => {
  const [state, setState] = useState<IStateStdTypes>('idle')
  const [value, setValue] = useState<string>('')
  const user = Storage.user.get()
  const toast = useToast()

  useEffect(() => {
    setValue('')
  }, [chatId])

  useEffect(() => {
    if (state === 'error') {
      toast.handler({
        content: 'Ocorreu um erro ao tentar enviar mensagem, tente novamente.',
        severity: 'error'
      })
    }
  }, [state])

  const sendMessage = async () => {
    const valueToSend = value.trim()
    if (valueToSend !== '' && state !== 'loading') {
      setState('loading')
      const response = await postChatMessage(chatId, {
        sender_id: user?.professional_id ?? '',
        chat_id: chatId ?? '',
        message_content: valueToSend
      })

      if (response.success) {
        setState('success')
        setValue('')
      } else {
        setState('error')
      }
    }
  }

  const handlewKeyEvent: React.KeyboardEventHandler<HTMLDivElement> = event => {
    if (event.key == 'Enter' && !event.ctrlKey && !event.shiftKey) {
      event.preventDefault()
      sendMessage()
    }
  }

  if (disabled) {
    return (
      <Grid
        container
        sx={{
          backgroundColor: 'action.disabledBackground',
          padding: '10px 10px',
          minHeight: '76px',
          justifyContent: 'center'
        }}
        spacing={2}
        alignItems={'center'}
      >
        <Typography
          sx={{
            color: 'text.secondary',
            textAlign: 'center'
          }}
        >
          Não é possível enviar mensagem para essa conversa
        </Typography>
      </Grid>
    )
  }

  return (
    <Grid
      container
      sx={{
        backgroundColor: 'defaultComponent.main',
        padding: '10px 10px'
      }}
      spacing={2}
      alignItems={'center'}
    >
      <InputBase
        sx={{ flex: 1 }}
        maxRows={4}
        multiline
        placeholder='Digite sua mensagem...'
        slotProps={{
          htmlInput: {
            maxLength: 1000
          }
        }}
        onKeyDown={handlewKeyEvent}
        value={value}
        onChange={event => {
          if (state !== 'loading') setValue(event.target.value)
        }}
      />

      <IconButton
        type='button'
        sx={{
          height: '40px',
          width: '40px'
        }}
        onClick={sendMessage}
        disabled={state == 'loading'}
        loading={state == 'loading'}
      >
        <SendIcon />
      </IconButton>
    </Grid>
  )
}

export default SendMessageArea
